module.exports = __webpack_public_path__ + "img/125.a1aa6c1c.jpg";